export const formatMetric = (value: string | number): string | number => {
	if (typeof value === 'string') {
		return value;
	}

	return value.toLocaleString('en-UK');
};
